import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import { p as props, d as defaults } from './componentEl-c8b73b10.js';
import { a as addClassNames, c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { a as addSpacingClasses, m as marginPropTypes, p as paddingPropTypes } from './spacing-7e57ffb0.js';

/*
Component to format blocks of text!!!
Not meant to wrap around other components!!!!!
*/
function Textblock({
  componentEl: Component,
  children,
  className,
  margin,
  padding,
  ...otherProps
}) {
  let cssClasses = ['st_textblock'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    padding,
    cssClasses
  });
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), children);
}
Textblock.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for component, if any */
  margin: marginPropTypes,
  /** margin for text block, if any */
  padding: paddingPropTypes
};
Textblock.defaultProps = {
  componentEl: defaults,
  className: null,
  margin: {
    all: 'none'
  },
  padding: {
    all: 'none'
  }
};

export { Textblock as T };
